var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerlessFramework(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 150,
    viewBox: "0 0 94 150",
    width: 94,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m88.778.701 2.693 2.375-.36 23.813-14.452 24.375 16.687-1.813.313 25.438-82.875 74.562v-28.437l19.812-33.313-29.125 4.688-.062-17.188s87.369-74.625 87.369-74.5zm-.341 56.599c.013.026-72.704 65.843-72.704 65.843l.047 15.25 72.813-65.562zm-46.916 13.454-32.641 4.984-2.328 1.969s-.015 9.031-.031 9.031l28.031-4.593zm44.951-57.858s-25.906 41.485-25.937 41.454l9.234-1.141 16.562-27.75z",
    fill: "#fd5750"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerlessFramework);
export default __webpack_public_path__ + "static/media/serverless-framework.86a77bd39c3eb68a50954b789cbf2a25.svg";
export { ForwardRef as ReactComponent };